<app-mobile-filter (clearFilters)="onClearFilters()" (close)="onCloseModal()">
  <ng-container content>
    <!-- pokazywanie przeszłych rezerwacji -->
    <ion-col
      class="ion-no-padding overflow-hidden"
      *ngIf="page !== 'reception'"
      size="12"
    >
    <ion-item lines="full" (click)="showDateCriteria = !showDateCriteria">
      <ion-label>{{ invitationServ.currentDateCriterion.name }}</ion-label>
      <ion-icon
        slot="end"
        name="chevron-down"
        [@toggleRotate]="showDateCriteria ? 'active' : 'inactive'"
      ></ion-icon>
    </ion-item>
    </ion-col>
    <ion-col
      *ngIf="page !== 'reception'"
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showDateCriteria ? 'active' : 'inactive'"
    >
      <ion-radio-group
      (ionChange)="onDateCriterionChanged($event)"
      [value]="invitationServ.currentDateCriterion.id"
      >
        <ion-item *ngFor="let criterion of invitationServ.filterDateCriteria" lines="none">
          <ion-radio [id]="criterion.id === 'future' ? 'futureRadio' : ''" slot="start" [value]="criterion.id"></ion-radio>
          <ion-label>{{ criterion.name }}</ion-label>
        </ion-item>
      </ion-radio-group>
      <div
      *ngIf="page !== 'reception'"
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="invitationServ.currentDateCriterion.id === 'range' ? 'active' : 'inactive'"
      >
      <div class="ion-padding-horizontal">
        <ion-label>
          {{ 'FROM:' | translate }}
        </ion-label>
        <app-date-time-picker
        pickerType="calendar"
        (afterPickerClosed)="invitationServ.filterDetails.dateStart = $event; invitationServ.reloadFilter()"
        [value]="invitationServ.filterDetails.dateStart"
        ></app-date-time-picker>
        
        <ion-label>
          {{ 'TO:' | translate }}
        </ion-label>
        <app-date-time-picker
        pickerType="calendar"
        (afterPickerClosed)="invitationServ.filterDetails.dateEnd = $event; invitationServ.reloadFilter()"
        [value]="invitationServ.filterDetails.dateEnd"
        ></app-date-time-picker>
      </div>
    </div>
  </ion-col>
    
    <!-- filtr po firmie -->
    <ion-col
      class="ion-no-padding"
      size="12"
      *ngIf="page === 'all' || page === 'reception'"
    >
      <ion-item lines="full" (click)="showCompanies = !showCompanies">
        <ion-label>{{ "ADD_INVITATION.COMPANY" | translate }}</ion-label>
        <ion-icon
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showCompanies ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-item>
    </ion-col>

    <ion-col
      *ngIf="page === 'all' || page === 'reception'"
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showCompanies ? 'active' : 'inactive'"
    >
      <ion-radio-group
        (ionChange)="onFilterCompany($event)"
        [value]="
          invitationServ.filterDetails.companyId
            ? invitationServ.filterDetails.companyId
            : 'null'
        "
      >
        <ion-item lines="none">
          <ion-radio slot="start" value="null"></ion-radio>
          <ion-label>{{ "ALL" | translate }}</ion-label>
        </ion-item>
        <ion-item *ngFor="let company of companyServ.companiesFilter" lines="none">
          <ion-radio slot="start" [value]="company.id"></ion-radio>
          <ion-label>{{ company.name }}</ion-label>
        </ion-item>
      </ion-radio-group>
    </ion-col>

    <ng-container *ngIf="page === 'reception'">
      <!-- filtr po dacie -->
      <ion-col class="ion-no-padding overflow-hidden" size="12">
        <ion-item lines="full" class="parking-filter-modal__date-container">
          <span class="margin-right-8">
            {{ "INVITATION.DATE" | translate }}
          </span>
          <app-date-time-picker
            class="parking-filter-modal__date"
            cssClass="border-0"
            pickerType="calendar"
            placeholder="{{ 'SPACE.RESERVATION_DATE' | translate }}"
            (afterPickerClosed)="onFilterDate($event)"
            [value]="startDate"
            #receptionDatePicker
            ></app-date-time-picker>
        </ion-item>
      </ion-col>

      <!-- Filtr po urządzemiu -->
      <ion-col class="ion-no-padding" size="12">
        <ion-item lines="full" (click)="showDevices = !showDevices">
          <ion-label>{{ "ADD_INVITATION.DEVICE" | translate }}</ion-label>
          <ion-icon
            slot="end"
            name="chevron-down"
            [@toggleRotate]="showDevices ? 'active' : 'inactive'"
          ></ion-icon>
        </ion-item>
      </ion-col>

      <ion-col
        class="ion-no-padding overflow-hidden"
        size="12"
        [@toggleHeight]="showDevices ? 'active' : 'inactive'"
      >
        <ion-radio-group
          (ionChange)="onFilterDevice($event)"
          [value]="
            invitationServ.filterDetails.deviceId
              ? invitationServ.filterDetails.deviceId
              : 'null'
          "
        >
          <ion-item lines="none">
            <ion-radio slot="start" value="null"></ion-radio>
            <ion-label>{{ "ALL" | translate }}</ion-label>
          </ion-item>
          <ion-item *ngFor="let device of invitationServ.devices" lines="none">
            <ion-radio slot="start" [value]="device.id"></ion-radio>
            <ion-label>{{ device.description }}</ion-label>
          </ion-item>
        </ion-radio-group>
      </ion-col>
    </ng-container>
  </ng-container>

  <ng-container button>
    <ng-container *ngIf="invitationServ.filterDetailsShowLoader">
      <img src="./assets/loading.svg" class="parking-filter-modal__loader" />
    </ng-container>
    <ng-container
      *ngIf="page !== 'reception' && !invitationServ.filterDetailsShowLoader"
    >
      {{ invitationServ.invitationCount }}
    </ng-container>
    <ng-container
      *ngIf="page === 'reception' && !invitationServ.filterDetailsShowLoader"
    >
      {{ invitationServ.entriesCount }}
    </ng-container>
  </ng-container>
</app-mobile-filter>
